 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		16: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		16: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"1e1aa607","2":"8349e13344ad661e3c55b1371af1791c1edef530","3":"ce40ad3e9d6b17f42970718e0d63c5ae0a3c1137","4":"8b2f6f47ad8af6ea5839b928b8d7430967fd1a76","5":"framework","6":"b8c5f904545b9a0d2cd5318a718d0cbd3cfc8018","7":"0a0bcd3b07f53e2868415b53c01ccd4fce998317","8":"56e313acfb576e5a29d9fa13a1c9c0e7bfa3f52c","9":"9f84e8b7e9242dff19ebaf4306abc4fa9f206740","10":"20ad93fdaebc1eb15803291ec2f76a415ae51543","11":"3ef0f144dacd3e094779fd5ef7c37b42b07b4460","12":"4f932ca84d2c5bd1d2188dc1bef0e03464fb2b0b","13":"AffirmWidget","14":"component---src-pages-account-orders-tsx","18":"Trustpilot","20":"component---src-pages-404-tsx","21":"component---src-pages-account-activate-tsx","22":"component---src-pages-account-addresses-tsx","23":"component---src-pages-account-index-tsx","24":"component---src-pages-account-invalid-token-tsx","25":"component---src-pages-account-login-tsx","26":"component---src-pages-account-pedal-points-tsx","27":"component---src-pages-account-register-tsx","28":"component---src-pages-account-reset-tsx","29":"component---src-pages-apps-product-registration-tsx","30":"component---src-pages-cart-tsx","31":"component---src-pages-pages-become-a-brand-ambassador-tsx","32":"component---src-pages-pages-corporate-bulk-orders-tsx","33":"component---src-pages-pages-pedal-points-tsx","34":"component---src-pages-pages-rider-styles-tsx","35":"component---src-pages-search-tsx","36":"component---src-templates-accessory-collection-tsx","37":"component---src-templates-accessory-product-list-tsx","38":"component---src-templates-accessory-product-tsx","39":"component---src-templates-author-tsx","40":"component---src-templates-bicycle-product-list-tsx","41":"component---src-templates-bicycle-product-tsx","42":"component---src-templates-blog-list-tsx","43":"component---src-templates-blog-post-tsx","44":"component---src-templates-customizer-tsx","45":"component---src-templates-home-page-tsx","46":"component---src-templates-page-tsx","47":"component---src-templates-quiz-bike-select-tsx"}[chunkId]||chunkId) + "-" + {"0":"bf4f5e5ab0c4b85857ad","1":"d5b469b37507edd3e781","2":"b2b658575396767d5de9","3":"85af0bbf7c2ed9185341","4":"0238e78f4758f70f1a92","5":"041948828c23feeb7e05","6":"903c9b4a37a55074e1cc","7":"0ef22c0ab6393f2c748c","8":"c3a8851dabb84c8b7e17","9":"9c4a12c942281cde89b1","10":"3b48f2a2700014f86fe4","11":"9ef924ec43b6af0043bb","12":"1fef43f189e2fb8453c9","13":"379b1117f64dcd2df2e2","14":"eb0efdc892b2e9442d20","18":"34214dc9daaf32ce9149","20":"429a92b5cdda17e249c1","21":"159c141fe67bfc422f41","22":"bad204073e205c2fea2d","23":"2ddbe0405e79eb744ce2","24":"5fdf4a15ec4449bb7079","25":"6bb4dd14d449f0e3e7d0","26":"0b2931faf8f142fcbaff","27":"ca3663a04c9b3d82be65","28":"d7d03c0f8dc2beb017bb","29":"79968c114d9d66cbacd8","30":"f2294e283e607b5f4a8e","31":"d87deb9829e4c44c3d49","32":"fa0fece74525d968914e","33":"f60b3d3c76bd2ba60247","34":"063118f8423da5181a20","35":"d9cb1f386f44aa94ea77","36":"f9ee55cf37a6f3ebeb7e","37":"9961d6587af0cab92063","38":"ce63cc0b40304ed683a9","39":"bf4b05084973651ed4a3","40":"a18de9167d8e0f92f162","41":"e424303edc2b3a915456","42":"557af5731626dde29b0b","43":"2c013fb71421f2770518","44":"786363ffcda50855c6b9","45":"7c893761760e40028d52","46":"ceb59309e728309b9608","47":"a6eb5c5437d017dc00b7","50":"f2595289ae6b246ec68c","51":"431e81d30aa5cfd81e3f","52":"756a6504d31d6354be6a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"1e1aa607","2":"8349e13344ad661e3c55b1371af1791c1edef530","3":"ce40ad3e9d6b17f42970718e0d63c5ae0a3c1137","4":"8b2f6f47ad8af6ea5839b928b8d7430967fd1a76","5":"framework","6":"b8c5f904545b9a0d2cd5318a718d0cbd3cfc8018","7":"0a0bcd3b07f53e2868415b53c01ccd4fce998317","8":"56e313acfb576e5a29d9fa13a1c9c0e7bfa3f52c","9":"9f84e8b7e9242dff19ebaf4306abc4fa9f206740","10":"20ad93fdaebc1eb15803291ec2f76a415ae51543","11":"3ef0f144dacd3e094779fd5ef7c37b42b07b4460","12":"4f932ca84d2c5bd1d2188dc1bef0e03464fb2b0b","13":"AffirmWidget","14":"component---src-pages-account-orders-tsx","18":"Trustpilot","20":"component---src-pages-404-tsx","21":"component---src-pages-account-activate-tsx","22":"component---src-pages-account-addresses-tsx","23":"component---src-pages-account-index-tsx","24":"component---src-pages-account-invalid-token-tsx","25":"component---src-pages-account-login-tsx","26":"component---src-pages-account-pedal-points-tsx","27":"component---src-pages-account-register-tsx","28":"component---src-pages-account-reset-tsx","29":"component---src-pages-apps-product-registration-tsx","30":"component---src-pages-cart-tsx","31":"component---src-pages-pages-become-a-brand-ambassador-tsx","32":"component---src-pages-pages-corporate-bulk-orders-tsx","33":"component---src-pages-pages-pedal-points-tsx","34":"component---src-pages-pages-rider-styles-tsx","35":"component---src-pages-search-tsx","36":"component---src-templates-accessory-collection-tsx","37":"component---src-templates-accessory-product-list-tsx","38":"component---src-templates-accessory-product-tsx","39":"component---src-templates-author-tsx","40":"component---src-templates-bicycle-product-list-tsx","41":"component---src-templates-bicycle-product-tsx","42":"component---src-templates-blog-list-tsx","43":"component---src-templates-blog-post-tsx","44":"component---src-templates-customizer-tsx","45":"component---src-templates-home-page-tsx","46":"component---src-templates-page-tsx","47":"component---src-templates-quiz-bike-select-tsx"}[chunkId]||chunkId) + "." + {"0":"4ebe5695956d57769172","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
